import SSORedirect from "./ssoPage";
import { SSOLoginPath } from "../../utils/RoutingConstants";

export const ssoRoutes = {
  path: SSOLoginPath.ssoLogin,
  component: SSORedirect,
};
